import { render, staticRenderFns } from "./PostDetailModal.vue?vue&type=template&id=17069584"
import script from "./PostDetailModal.vue?vue&type=script&lang=js"
export * from "./PostDetailModal.vue?vue&type=script&lang=js"
import style0 from "./PostDetailModal.vue?vue&type=style&index=0&id=17069584&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports